import {
  Alert,
  AlertIcon,
  Button,
  CloseButton,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  AlertTitle,
  ModalOverlay,
  Text,
} from "@chakra-ui/react";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { REQUEST_DELETE_MASTER_PROMOCODE } from "../../store/promoCode/promoCodeActionTypes";
import { usePromoCodeMaster } from "../../store/promoCode/reducer";
interface Props {
  promocode: Record<string, any>;
  isOpen: any;
  onClose: any;
}
const PromocodeDelete: React.FC<Props> = ({ promocode, isOpen, onClose }) => {
  const dispatch = useDispatch();
  const { masterPromoCode: promocodes, busy, message } = usePromoCodeMaster();
  const { _id } = promocode;
  useEffect(() => {
    const findLink = promocodes.find(
      (val: Record<string, any>) => val._id === _id
    );
    if (!findLink) {
      onClose();
    }
  }, [_id, promocodes, onClose]);

  return (
    <Modal isOpen={isOpen} onClose={onClose} closeOnOverlayClick={false}>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Delete Promocode</ModalHeader>
        <ModalCloseButton disabled={busy} />
        <ModalBody>
          <Text fontWeight="bold" mb="1rem">
            Are you sure to delete? {promocode.promotionCode}
          </Text>
        </ModalBody>
        <ModalFooter>
          <Button variant="outline" mr={3} onClick={onClose} disabled={busy}>
            Close
          </Button>
          <Button
            colorScheme="red"
            variant={"outline"}
            mr={3}
            disabled={busy}
            onClick={() => {
              dispatch({
                type: REQUEST_DELETE_MASTER_PROMOCODE,
                payload: { _id: promocode._id },
              });
            }}
          >
            Submit
          </Button>
        </ModalFooter>
        {message && (
          <ModalFooter>
            <Alert status="error">
              <AlertIcon />
              <AlertTitle mr={2}>{message}</AlertTitle>
              <CloseButton position="absolute" right="8px" top="8px" />
            </Alert>
          </ModalFooter>
        )}
      </ModalContent>
    </Modal>
  );
};

export default PromocodeDelete;
